import styles from './sociogram-surveys-list.module.scss'
import { useTranslation } from 'react-i18next'
import BupSpinner from '@BUP/components/Loading/Spinner'
import AlertComponent from '@BUP/components/Generics/Alert'
import CollapsePanel from '..'
import SociogramTable from '@BUP/components/Generics/Table/SociogramTable'
import { useGetSociogram } from '@BUP/hooks/Sociogram/useGetSociogram'
import { useGetSurveysBySociogramId } from '@BUP/hooks/Sociogram/useGetSurveysBySociogramId'
import { useGetOrganizationRecommendations } from '@BUP/hooks/Sociogram/recommendations/useGetOrganizationRecommendations'
import FinishSociogramModal from './finish-sociogram-modal'
import ButtonComponent from '../../Button'
import { ReloadOutlined } from '@ant-design/icons'

const SociogramSurveysList = ({ sociogramId, arraySociogramsIds }) => {
  const i18n = useTranslation()
  const { isLoadingSociogram, dataSociogram, getSociogram, errorSociogram, isFetchingSociogram } =
  useGetSociogram(sociogramId)

  const { data: surveysData, isLoading: isLoadingDataSurveys, error: errorDataSurveys, refetch: getSurveys, isFetching: isFetchingSurveys } =
  useGetSurveysBySociogramId(sociogramId)

  const { isLoadingRecommendations, isFetchingRecommendations, dataRecommendations, errorResultRecommendations } = useGetOrganizationRecommendations()

  const reloadSurveys = async () => {
    await getSurveys()
  }

  const reloadSociogram = async () => {
    await getSociogram()
  }

  if (isLoadingSociogram || isLoadingRecommendations || isFetchingRecommendations || isLoadingDataSurveys || isFetchingSurveys) {
    return (
      <div className={styles.loading_wrapper}>
        <BupSpinner size='large' />
      </div>
    )
  }

  if (errorSociogram || !dataSociogram || dataSociogram.length === 0) {
    return (
      <div className={styles.error_wrapper}>
        <AlertComponent
          message={i18n.t('pages.data.sociogram.activeSociogramEce.sociogramSurveysList.errorSociogram')}
          type='error'
        />

        <ButtonComponent buttonText={i18n.t('common.resources.generic.actions.reload.generic')} size='small' icon={<ReloadOutlined />} onClick={reloadSociogram} />
      </div>
    )
  }

  if (errorDataSurveys || !surveysData || surveysData.length === 0) {
    return (
      <div className={styles.error_wrapper}>
        <AlertComponent
          message={i18n.t('pages.data.sociogram.activeSociogramEce.sociogramSurveysList.errorSurveys')}
          type='error'
        />
        <ButtonComponent buttonText={i18n.t('common.resources.generic.actions.reload.surveys')} size='small' icon={<ReloadOutlined />} onClick={reloadSurveys} />
      </div>
    )
  }

  let combinedDataSurveys

  if (dataRecommendations) {
    combinedDataSurveys = surveysData.map(survey => {
      const result = dataRecommendations.find(result => result.resultId === survey.results[0]?.id)

      if (result) {
        return {
          ...survey,
          resource: result
        }
      }
      return {
        ...survey,
        resource: null
      }
    })
  } else {
    combinedDataSurveys = surveysData
  }

  const sociogram = dataSociogram[0]
  const { isDone: isDoneSociogram } = sociogram

  return (
    <div
      className={styles.surveys_container}
      data-test='surveys-list-container'
    >
      <div className={styles.collapse_wrapper}>
        <CollapsePanel
          id={sociogramId}
          label={
            <h5 className={styles.collapse_label}>{i18n.t('pages.data.sociogram.activeSociogramEce.sociogramSurveysList.collapseTitle')}</h5>
            }
          shadow
          borderBottom
          isOpenCollapse
        >
          <div
            className={styles.table_wrapper}
            data-test='surveys-list-table-wrapper'
          >
            <SociogramTable
              sociogram={sociogram}
              error={errorSociogram}
              loadingSociogram={isLoadingSociogram || isFetchingSociogram}
              surveysData={combinedDataSurveys}
              isLoadingDataSurveys={isLoadingDataSurveys || isFetchingSurveys || isLoadingRecommendations}
              errorResultRecommendations={errorResultRecommendations}
            />
          </div>
        </CollapsePanel>
      </div>
      <FinishSociogramModal
        sociogramId={sociogramId}
        isDoneSociogram={isDoneSociogram}
        getSociogram={getSociogram}
        arraySociogramsIds={arraySociogramsIds}
      />
    </div>
  )
}

export default SociogramSurveysList
